// extracted by mini-css-extract-plugin
export default {"download":"download___b1aa854c4e0af9ede652"};